import { normalize_text, to_array } from './company_cases_common';

export function owner_label(record = {}, users_by_id = new Map()) {
  return normalize_text(first_value([
    assignment_owner_label(record),
    assignment_user_id_label(record, users_by_id),
    record?.owner,
    record?.assigned_to,
    record?.handler,
    record?.assignee_name,
    'Unassigned',
  ]));
}

export function assigned_owner_label(assignments = []) {
  const normalized_assignments = to_array(assignments);
  const owner_assignments = normalized_assignments.filter(is_owner_assignment);
  const fallback_assignments = normalized_assignments.filter((assignment) => !is_coordinator_assignment(assignment));
  const visible_assignments = owner_assignments.length ? owner_assignments : fallback_assignments;
  return visible_assignments.map(assignment_label).filter(Boolean).join(', ');
}

export function with_assigned_owner(case_item = {}, assignments = []) {
  const owner = assigned_owner_label(assignments);
  const next_case = assignments.length
    ? { ...case_item, application_assigned_users: assignments }
    : case_item;
  return { ...next_case, owner: owner || 'Unassigned' };
}

function assignment_owner_label(record = {}) {
  return assigned_owner_label(first_value([
    record?.assigned_users,
    record?.assignments,
    record?.assigned_panel_members,
    record?.application_assigned_users,
  ], []));
}

function assignment_user_id_label(record = {}, users_by_id = new Map()) {
  return to_array(record?.assignment_user_ids)
    .map((value) => user_label_from_directory(value, users_by_id))
    .filter(Boolean)
    .join(', ');
}

function assignment_label(assignment = {}) {
  const name = normalize_text(first_value([
    assignment?.assigned_to_name,
    assignment?.name,
    assignment?.user_name,
    assignment?.full_name,
    assignment?.assigned_to?.full_name,
    assignment?.assigned_to?.name,
    assignment?.assigned_to?.email,
    assignment?.assigned_to_email,
    assignment?.email,
  ]));
  return name;
}

function assignment_role(assignment = {}) {
  return normalize_text(first_value([
    assignment?.role_name,
    assignment?.role,
    assignment?.assigned_role,
    assignment?.assigned_profile_role?.role?.role,
  ]));
}

function is_owner_assignment(assignment = {}) {
  const role = assignment_role(assignment).toLowerCase();
  return role.includes('owner')
    || role.includes('case owner')
    || role.includes('case_owner')
    || role.includes('case handler')
    || role.includes('handler')
    || role.includes('reviewer')
    || role === 'owner';
}

function is_coordinator_assignment(assignment = {}) {
  return assignment_role(assignment).toLowerCase().includes('coordinator');
}

function first_value(values = [], fallback = '') {
  return values.find((value) => value !== undefined && value !== null && value !== '') ?? fallback;
}

function user_label_from_directory(value, users_by_id = new Map()) {
  const user_id = Number(value);
  if (!Number.isFinite(user_id) || user_id <= 0) return '';

  const user = users_by_id.get(user_id);
  if (!user) return '';

  return normalize_text(first_value([
    [user?.first_name, user?.last_name].map(normalize_text).filter(Boolean).join(' '),
    user?.full_name,
    user?.name,
    user?.email,
    user?.username,
  ]));
}
